import { Address } from "types/address";

type PlaceSelectProps = {
  // eslint-disable-next-line
  addressObject: any;
  updateFullAddress: (address: Address) => void;
  address: Address;
};

type AddressComponent = {
  format: "short_name" | "long_name";
  key: keyof Address;
};

const componentForm: Record<string, AddressComponent> = {
  street_number: {
    format: "short_name",
    key: "address",
  },
  locality: {
    format: "long_name",
    key: "city",
  },
  administrative_area_level_1: {
    format: "short_name",
    key: "state",
  },
  postal_code: {
    format: "short_name",
    key: "postcode",
  },
  country: {
    format: "short_name",
    key: "country",
  },
};

const addressTypes = ["route", "sublocality_level_1", "neighborhood"];

export const handlePlaceSelect = ({
  addressObject,
  updateFullAddress,
  address,
}: PlaceSelectProps) => {
  const updatedAddress: Address = { ...address };

  for (const component of addressObject.address_components as google.maps.GeocoderAddressComponent[]) {
    const addressType = component.types[0];

    if (Object.keys(componentForm).includes(addressType)) {
      const { format, key } = componentForm[addressType];
      const value =
        format === "short_name" ? component.short_name : component.long_name;
      if (addressType === "street_number") {
        let addressField = "";
        let subpremise = "";
        addressObject.address_components.forEach(
          (addressComponent: google.maps.GeocoderAddressComponent) => {
            if (addressTypes.includes(addressComponent.types[0])) {
              addressField = addressField
                ? `${addressField}, ${addressComponent.long_name}`
                : addressComponent.long_name;
            } else if (addressComponent.types[0] === "subpremise") {
              subpremise = `${addressComponent.long_name}/`;
            }
          },
        );
        updatedAddress.address = `${subpremise}${value} ${addressField}`;
      } else {
        updatedAddress[key] = value;
      }
    }
  }
  updateFullAddress(updatedAddress);
};
